'use strict';

import React, { Component } from 'react';

import styles from './assets/indexResponse.module.css';
import { Link } from 'react-router-dom';
const print = function (value) { };
class DDS_lanhupage_4 extends Component {
  state = {};
  setValue(val) { }
  onNextSlide = () => {
    //var i = this.state.currentSlideIndex + 1;
    //this.props.onClickNextcurrentSLide(i)
    document.getElementById('mainwrap').scrollBy({
      top: 20, // 垂直滚动500px
      left: 0, // 水平位置（这里不改变）
      behavior: 'smooth' // 平滑滚动效果
    });
  }
  render() {
    return (
      <div className={`${styles.page} flex-col`}>
        <div className={`${styles['box_22']} indexResponse_box_22__23J-F flex-row indexResponse_box_22__1PAuRc`}>
          <div className={`${styles['block_8']} flex-col justify-between indexResponse_block_8__21oUD`}>

            <div className={`${styles['block_2']} flex-col indexResponse_block_2__1yJgF`}>
              <span class="indexResponse_text_3__1uKQD indexResponse_text_3__32nG- ">JiaYingInternationl</span>
              <div className={`${styles['box_4']} flex-col indexResponse_box_4__1a3Ln`} />
              <div className={`${styles['box_5']} flex-col indexResponse_box_5__1AS9f`} />
              <div className={`${styles['box_6']} flex-col indexResponse_box_6__3mjuJ`} />
              <span className={`${styles['text_4']} indexResponse_text_4__3ZiI9`}>合作院校</span>
              <div className={`${styles['box_7']} flex-col indexResponse_box_7__NIaJ3 `} />

              <img
                className={`${styles['image_4']} indexResponse_image_4__3MqGs`}
                src={
                  require('./assets/img/SketchPng2a8675b81e27764903f1304c221689ced87ea3dbbfa3996be807f85d83d596d3.png')
                }
              />

            </div>
          </div>
          <div className={`${styles['block_9']} flex-col indexResponse_block_9__3Th8P `}>
            <div className={`${styles['box_1']} flex-col indexResponse_box_1__3EMJL`}>
            </div>
            <img
              className={`clickable ${styles['image_2']} indexResponse_image_2__2ee7o`}
              onClick={() => this.onNextSlide()}
              src={
                require('./assets/img/SketchPngd08825a154ca581054fc75372f7edca364d9ed279fa43b889c445ea09526f894.png')
              }
            />
            <img
              className={`clickable ${styles['image_3']} indexResponse_image_3__wnH0P`}

              src={
                require('./assets/img/SketchPng1043bd5c5c67398c345b9723acb5e8d9485cafdf0c89eca728c1f52603b44a47.png')
              }
            />

          </div>
        </div>
        <div className={`${styles['box_20']} indexResponse_box_20__ENVCc  indexResponse_box_20__1VkIY fade-out`}>
          <div className={`flex-col indexResponse_box_22__1j5c4`}>
            <div className={`${styles['section_7']}  slide-left`}>

              <div className={`${styles['box_2']} flex-col indexResponse_box_2__8d_Sh`}>
                <div className='flex-row justify-between visible'>
                  <div className={`indexrepose_font_title indexrepose-hhezuoy`}>合作院校</div>
                  <Link to='/universities'>
                    <div className='linkTomore clickable' >
                      <span>查看更多</span>
                      <img
                        className={`${styles['label_2']} indexResponse_label_2__1EOTO`}
                        src={
                          require('./assets/img/SketchPngd5cc31c7e94b2414b3af4c585037852c61505118557607dec9e414b31c008970.png')
                        }
                      />
                    </div>
                  </Link>
                </div>
                <div className={`${styles['list_3']} flex-row visible transition indexResponse_list_3__2AOqN`}>
                  <Link to={`/university/JINYIN`} className={` ${styles['list-items_1-0']} flex-col indexResponse_list-items_1-0__CozHx list_bg_1 clickable`}>
                    <div className={`indexResponse_text-wrapper_3-0__3C-w7 flex-col indexResponse_text-wrapper_3-0__ai8yf `}>
                      <span className={`${styles['text_4-0']} indexResponse_text_4-0__f8eG-`}>精英大学</span>
                    </div>
                  </Link>

                  <Link to={`/university/MMU`} className={`${styles['list-items_1-0']} flex-col indexResponse_list-items_1-0__CozHx list_bg_2 clickable`}>
                    <div className={`indexResponse_text-wrapper_3-0__3C-w7 flex-col indexResponse_text-wrapper_3-0__ai8yf `}>
                      <span className={`${styles['text_4-0']} indexResponse_text_4-0__f8eG-`}>多媒体大学</span>
                    </div>
                  </Link>

                  <Link to={`/university/JILONGPO`} className={`${styles['list-items_1-0']} flex-col indexResponse_list-items_1-0__CozHx list_bg_3 clickable`}>
                    <div className={`indexResponse_text-wrapper_3-0__3C-w7 flex-col indexResponse_text-wrapper_3-0__ai8yf`}>
                      <span className={`${styles['text_4-0']} indexResponse_text_4-0__f8eG-`}>基隆坡基础大学</span>
                    </div>
                  </Link>

                  <Link to={`/university/MASA`} className={`${styles['list-items_1-0']} flex-col indexResponse_list-items_1-0__CozHx list_bg_4 clickable`}>
                    <div className={`indexResponse_text-wrapper_3-0__3C-w7 flex-col indexResponse_text-wrapper_3-0__ai8yf`}>
                      <span className={`${styles['text_4-1']} indexResponse_text_4-1__7l-uA`}>马萨大学</span>
                    </div>
                  </Link>

                  <Link to={`/university/CYBERJAYA`} className={`${styles['list-items_1-0']} flex-col indexResponse_list-items_1-0__CozHx list_bg_5 clickable`}>
                    <div className={`indexResponse_text-wrapper_3-0__3C-w7 flex-col indexResponse_text-wrapper_3-0__ai8yf`}>
                      <span className={`${styles['text_4-2']} indexResponse_text_4-2__26MAT`}>赛城大学</span>
                    </div>
                  </Link>

                  <Link to={`/university/UPC`} className={`${styles['list-items_1-0']} flex-col indexResponse_list-items_1-0__CozHx list_bg_6 clickable`}>
                    <div className={`indexResponse_text-wrapper_3-0__3C-w7 flex-col indexResponse_text-wrapper_3-0__ai8yf`}>
                      <span className={`${styles['text_4-2']} indexResponse_text_4-2__26MAT`}>加泰罗尼亚理工大学</span>
                    </div>
                  </Link>

                </div>

              </div>



            </div>
          </div>

        </div>
      </div>
    );
  }
}
export default DDS_lanhupage_4;
